import { SimpleMuiButton } from '../layout/SimpleMuiButton'
import { useTranslation } from '@dreamstack/i18n'
import { Plus } from '@dreamstack/icons/src/icon-components/Plus'
import { RouterOutputs } from '@dreamstack/trpc/client'
import map from 'lodash/map'
import take from 'lodash/take'
import type { FunctionComponent } from 'react'
import { useCallback, useMemo, useState } from 'react'
import { HeadingH3 } from '../layout/Texts'
import { NewsHubStackGrid } from '../news/NewsHubStackGrid'
import { LexiconPreview } from './LexiconPreview'

export const LoadMoreArticles: FunctionComponent<
  React.PropsWithChildren<{
    articles: RouterOutputs['cms']['getLexiconArticlePreviews']['items']
  }>
> = ({ articles }) => {
  const t = useTranslation()
  const paginationSteps = 12
  const [pagination, setPagination] = useState(paginationSteps)

  const loadMore = useCallback(() => {
    setPagination((p) => p + paginationSteps)
  }, [setPagination])

  const paginatedArticles = useMemo(
    () => take(articles, pagination),
    [articles, pagination]
  )

  const showLoadMoreButton = useMemo(() => {
    if (!articles) return false
    return pagination < articles.length
  }, [pagination, articles])

  if (!articles) return null

  return (
    <>
      {!paginatedArticles?.length ? (
        <>
          <div>
            <HeadingH3 className="text-center my-px-160 max-w-[580px] mx-auto">
              {t('accentro:newsHub:articleFilterNoMatchesHeading')}
            </HeadingH3>
          </div>
        </>
      ) : (
        <NewsHubStackGrid>
          {map(paginatedArticles, (article, i) => {
            return <LexiconPreview key={i} lexiconArticle={article} />
          })}
        </NewsHubStackGrid>
      )}
      <div className="flex justify-center mt-px-40 mb-px-40 md:mt-px-80 md:mb-px-128">
        {showLoadMoreButton && (
          <SimpleMuiButton
            onClick={loadMore}
            variant={'outlined'}
            color={'primary'}
            startIcon={<Plus />}
          >
            {t('accentro:newsHub.loadMoreNews')}
          </SimpleMuiButton>
        )}
      </div>
    </>
  )
}
